import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        body: {
            backgroundColor: theme.palette.secondary[100],
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
        },
        title: {
            fontSize: theme.typography.h1.fontSize,
            paddingTop: 20,
            paddingBottom: 20,
            color: theme.palette.common.black,
            fontWeight: theme.typography.subtitle1.fontWeight,
        },
        subTitle: {
            color: theme.palette.common.black,
            fontSize: theme.typography.h3.fontSize,
            fontWeight: theme.typography.h3.fontWeight,
        },
        icon: {
            height: 64,
            width: 64,
        },
    }
})

export default useStyles
